export class SpreadFolioObserver {
    private spreads: HTMLElement[];
    private counterEl: HTMLElement | null;
    private counterMobileEl: HTMLElement | null;
    private metaContainer: HTMLElement | null;
    private metaContainerMobile: HTMLElement | null;
    private metaItems: HTMLElement[];
    private metaItemsMobile: HTMLElement[];
    private navItems: HTMLElement[];
    private observer: IntersectionObserver;
    private activeIndex: number = 0;
    private activeSlug: string | null = null;

    constructor() {
        this.spreads = Array.from(
            document.querySelectorAll<HTMLElement>('.spread[data-spread-index]')
        );

        this.counterEl = document.getElementById('folio-counter');
        this.counterMobileEl = document.getElementById('folio-counter-mobile');
        this.metaContainer = document.querySelector<HTMLElement>('[data-works-metadata]');
        this.metaContainerMobile = document.querySelector<HTMLElement>('[data-works-metadata-mobile]');
        this.metaItems = Array.from(
            document.querySelectorAll<HTMLElement>('[data-works-metadata] [data-work-meta]')
        );
        this.metaItemsMobile = Array.from(
            document.querySelectorAll<HTMLElement>('[data-works-metadata-mobile] [data-work-meta]')
        );
        this.navItems = Array.from(
            document.querySelectorAll<HTMLElement>('[data-work-nav]')
        );

        console.log('[SpreadFolioObserver] init:', {
            spreads: this.spreads.length,
            metaContainer: !!this.metaContainer,
            metaItems: this.metaItems.length,
            metaItemsMobile: this.metaItemsMobile.length,
            navItems: this.navItems.length
        });

        if (this.spreads.length === 0) return;

        // Remove hidden attribute from all items (CSS handles visibility)
        this.metaItems.forEach(meta => meta.removeAttribute('hidden'));
        this.metaItemsMobile.forEach(meta => meta.removeAttribute('hidden'));

        // Initialize: show first item
        if (this.metaItems.length > 0) {
            this.metaItems[0].classList.add('is-visible');
        }
        if (this.metaItemsMobile.length > 0) {
            this.metaItemsMobile[0].classList.add('is-visible');
        }

        this.observer = new IntersectionObserver(
            this.onIntersect,
            {
                root: null,
                threshold: 0.5
            }
        );

        this.observe();
    }

    private observe() {
        this.spreads.forEach(spread => this.observer.observe(spread));
    }

    private updateMetadata(slug: string, spreadIndex: number) {
        if (this.activeSlug === slug) return;

        // Update desktop meta items
        if (this.metaItems.length > 0) {
            const metaIndex = this.metaItems.findIndex(
                meta => meta.dataset.workMeta === slug
            );

            if (metaIndex !== -1) {
                this.metaItems.forEach((meta, i) => {
                    meta.classList.remove('is-visible', 'is-past');
                    if (i < metaIndex) {
                        meta.classList.add('is-past');
                    } else if (i === metaIndex) {
                        meta.classList.add('is-visible');
                    }
                });
            }
        }

        // Update mobile meta items
        if (this.metaItemsMobile.length > 0) {
            const mobileMetaIndex = this.metaItemsMobile.findIndex(
                meta => meta.dataset.workMeta === slug
            );

            if (mobileMetaIndex !== -1) {
                this.metaItemsMobile.forEach((meta, i) => {
                    meta.classList.remove('is-visible', 'is-past');
                    if (i < mobileMetaIndex) {
                        meta.classList.add('is-past');
                    } else if (i === mobileMetaIndex) {
                        meta.classList.add('is-visible');
                    }
                });
            }
        }

        console.log('[SpreadFolioObserver] updateMetadata:', slug);
        this.activeSlug = slug;

        // Update active nav item
        this.navItems.forEach(nav => {
            nav.classList.toggle('is-active', nav.dataset.workNav === slug);
        });
    }

    private onIntersect: IntersectionObserverCallback = (entries) => {
        for (const entry of entries) {
            if (!entry.isIntersecting) continue;

            const el = entry.target as HTMLElement;
            const indexStr = el.dataset.spreadIndex;
            const total = el.dataset.spreadTotal;

            if (!indexStr || !total) continue;

            const index = parseInt(indexStr, 10) - 1; // Convert to 0-based

            // Update folio counter (both desktop and mobile)
            const counterText = `${indexStr}/${total}`;
            if (this.counterEl) {
                this.counterEl.textContent = counterText;
            }
            if (this.counterMobileEl) {
                this.counterMobileEl.textContent = counterText;
            }

            // Update metadata if this is a work spread
            const spreadId = el.id;
            console.log('[SpreadFolioObserver] intersect:', spreadId, index);

            if (spreadId.startsWith('work-')) {
                const slug = spreadId.replace('work-', '');
                this.updateMetadata(slug, index);
            }

            return;
        }
    };
}
